module.exports = __webpack_public_path__ + "images/hauler-and-phone.c39d2c89ffa90f4cd80dbd9e5531345d.png";